import { isPastShift } from '../../../../backend/utils/shiftStateUtils';
import { ExpandableCard } from '../../../../ui/components/ExpandableCard';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { Card } from '@mui/material';
import React, { useCallback, useMemo, useState } from 'react';
import { ShiftDetails } from '../../shift-details';
import { ShiftDetailsCards } from '../../shift-details/components/ShiftDetailsCards';
import { useParticipantsByShiftId } from '../../shift/hooks/useParticipantsByShiftId';
export const Shift = ({ shift, indexInList, location, eagerLoadParticipants, statusBadgeLabel, renderStatusBadgeLabel, allowMissionChange, showShiftDetailsCardToggle, analyticsComponent, actionsComponent, renderActionsComponent, renderParticipantsTable, }) => {
    const { t } = useMissionsTranslation();
    const [shiftIdToLoad, setShiftIdToLoad] = useState(eagerLoadParticipants ? shift.id : undefined);
    const { participants, isLoading, fetchParticipants } = useParticipantsByShiftId({
        shiftId: shiftIdToLoad,
        filterAccountSystemStatuses: isPastShift(shift.data) ? undefined : ['active'],
    });
    const statusBadgeLabelFinal = useMemo(() => {
        if (!renderStatusBadgeLabel) {
            return statusBadgeLabel;
        }
        if (isLoading) {
            return 'Loading...';
        }
        return participants ? renderStatusBadgeLabel(participants, fetchParticipants) : undefined;
    }, [renderStatusBadgeLabel, isLoading, participants, fetchParticipants, statusBadgeLabel]);
    const tableComponentFinal = useMemo(() => {
        if (isLoading) {
            return 'Loading...';
        }
        return participants ? renderParticipantsTable(participants, fetchParticipants) : undefined;
    }, [isLoading, participants, fetchParticipants, renderParticipantsTable]);
    const actionsComponentFinal = useMemo(() => {
        if (!renderActionsComponent) {
            return actionsComponent;
        }
        if (isLoading) {
            return 'Loading...';
        }
        return participants ? renderActionsComponent(participants, fetchParticipants) : undefined;
    }, [actionsComponent, renderActionsComponent, isLoading, participants, fetchParticipants]);
    const handleExpand = useCallback(() => {
        setShiftIdToLoad(shift.id);
    }, [shift.id]);
    return (React.createElement(Card, { variant: 'outlined', "data-test": `shift-${shift.id}`, role: 'listitem' },
        React.createElement(ExpandableCard, { id: shift.id, cardAriaLabel: typeof indexInList === 'number'
                ? t('shifts.ariaLabels.shiftSummaryWithPosition', {
                    position: indexInList + 1,
                    date: new Date(shift.data.startTime),
                })
                : t('shifts.ariaLabels.shiftSummary', {
                    date: new Date(shift.data.startTime),
                }), collapseAriaLabel: t('shifts.ariaLabels.collapseShiftDetailsRow'), expandAriaLabel: t('shifts.ariaLabels.expandShiftDetailsRow'), cardContent: React.createElement(ShiftDetails, { location: location, shiftId: shift.id, stopTime: shift.columns.stopTime, startTime: shift.columns.startTime, missionName: shift.missionName, countyName: shift.columns.countyName, statusBadgeLabel: statusBadgeLabelFinal, analyticsComponent: analyticsComponent, actionsComponent: actionsComponentFinal }), onExpand: handleExpand },
            isLoading && React.createElement("div", null, "Loading..."),
            participants ? (React.createElement(React.Fragment, null,
                React.createElement(ShiftDetailsCards, { shift: shift, participants: participants, allowMissionChange: allowMissionChange, showToggle: showShiftDetailsCardToggle }),
                tableComponentFinal)) : undefined)));
};
